import { Record, List } from 'immutable';
import { actionTypes, pagingActions, fetchListActions, disableBatchActions, enableBatchActions } from './registered-participants.actions';
import * as api from '../../api';
import { authActions } from '../../auth';
import { pagingDataUtilities } from '../../common';

export const RegisteredParticipantState = Record({
  pagingData: pagingDataUtilities.PagingState({
    sortBy : 'lname',
    itemsPerPage : 50
  }),
  searchInput: '',
  searchQuery: '',
  listState: api.ApiCallState({}),
  disableBatchState: api.ApiCallState({}),
  enableBatchState: api.ApiCallState({}),
  enabledParticipants: List([]),
  disabledParticipants: List([]),
  radioButtonValue: 'true'
});

const participantStatus = {
  enabled : 'Enabled',
  disabled : 'Disabled'
}

export const registeredParticipantsReducer = (initialState = new RegisteredParticipantState(), action) => {

  var state = initialState.set('pagingData',
    pagingDataUtilities.pagingReducer(initialState.get('pagingData'), action, pagingActions));

  const invalidateActions = pagingActions.allTypes
    .concat([
      authActions.actionTypes.CREATE_ETO_SESSION_SUCCESS,
      actionTypes.START_SEARCH,
      disableBatchActions.success,
      enableBatchActions.success
    ]);

  state = state.set('listState',
    api.apiCallReducer(state.get('listState'), action, fetchListActions, invalidateActions));

  state = state.set('disableBatchState',
    api.apiCallReducer(state.get('disableBatchState'), action, disableBatchActions));

  state = state.set('enableBatchState',
    api.apiCallReducer(state.get('enableBatchState'), action, enableBatchActions));

  switch (action.type) {
    case disableBatchActions.success:
      const enabledParticipants = state.get('enabledParticipants');
      return state.set('enabledParticipants', enabledParticipants.filter(id => !action.data.successResults.some(val => val.id === id)));
    case enableBatchActions.success:
      const disabledParticipants = state.get('disabledParticipants');
      return state.set('disabledParticipants', disabledParticipants.filter(id => !action.data.successResults.some(val => val.id === id)));
    case actionTypes.SELECT_PARTICIPANT: {
      const section = action.status === participantStatus.enabled ? 'enabledParticipants' : 'disabledParticipants';
      const selectedParticipants = state.get(section);
      var index = selectedParticipants.findIndex(participantId => participantId === action.id);
      if(index === -1) {
        return state.set(section, selectedParticipants.push(action.id));
      }
      else {
        return state.set(section, selectedParticipants.delete(index));
      }
    }
    case actionTypes.SELECT_ALL_PARTICIPANTS: {
      const enabledParticipants = state.get('enabledParticipants');
      const disabledParticipants = state.get('disabledParticipants');
      const listState = state.get('listState');
      const { data } = listState || {};

      if(data && data.results) {
        var modifiedState = state;

        modifiedState = modifiedState.set('enabledParticipants', enabledParticipants.filter(id => !data.results.some(val => val.participantId === id)))
                                     .set('disabledParticipants', disabledParticipants.filter(id => !data.results.some(val => val.participantId === id)));
        if(!data.results.every(val => enabledParticipants.some(id => id === val.participantId) || disabledParticipants.some(id => id === val.participantId))) {
          data.results.forEach(participant => {
            var section = participant.status === participantStatus.enabled ? 'enabledParticipants' : 'disabledParticipants';
            modifiedState = modifiedState.set(section, modifiedState.get(section).push(participant.participantId));
          });
        }
        return modifiedState;
      }
      else {
        return state;
      }
    }
    case actionTypes.SET_SEARCH_TEXT:
      return state.set('searchInput', action.text);
    case actionTypes.START_SEARCH:
      return state.set('searchQuery', state.get('searchInput')).setIn(['pagingData', 'currentPage'], 1);
    case actionTypes.SET_SELECTED_SAVE_OPTION:
      return state.set('radioButtonValue', action.value);
    default:
      return state
  }
}
